export const hotelInformationMockData = {
  hotelInformationData: {
    property: {
      id: 'NYCES',
      parking: [
        {
          fees: {
            fee: 'Fee: 50 USD daily',
            description: 'Off-site parking, fee: 50 USD daily',
          },
          description: null,
        },
        {
          fees: {
            fee: 'Fee: 70 USD daily',
            description: 'Valet parking, fee: 70 USD daily',
          },
          description: null,
        },
        {
          fees: {
            fee: null,
            description: null,
          },
          description: 'Valet Parking is $70 for regular car and $80 for oversized car daily.',
        },
      ],
      policies: {
        checkInTime: '16:00',
        checkOutTime: '11:00',
        smokefree: true,
        petsAllowed: true,
        petsPolicyDescription: 'test pet policy desc',
        petsPolicyDetails: [{ maximumPetsDesc: 'test pet desc', nonRefundableFee: 20 }],
      },
      basicInformation: {
        name: 'Courtyard New York Manhattan/Fifth Avenue',
      },
    },
  },
  amenitiesData: {
    property: {
      __typename: 'Hotel',
      facilitiesAndServices: [
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Equipment' },
          description: 'Computers',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.1' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Equipment' },
          description: 'Printers',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.28' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Copy service',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.2' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Fax service',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.9' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Full business center, onsite',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUSKOR.72' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Full-service business center',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.71' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Network/Internet printing',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.57' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Business Services' },
          description: 'Overnight delivery/pickup',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'BUS.62' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Accessible guest rooms with 32” wide doorways',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'ADA.11' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Accessible route from public entrance to accessible guest rooms ',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'ADA.12' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Alarm clock telephone ringers',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.39' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Bathroom grab bars',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.38' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Bathtub grab bars',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.114' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Bathtub seat',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.44' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Business Center ',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.7' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Deadbolt locks, lowered',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.17' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Door night guards, lowered',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.112' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Doors with lever handles',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'All Rooms/Suites', value: null }],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Electrical outlets, lowered',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.113' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Fitness Center ',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.6' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Flashing door knockers',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.13' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Hearing accessible rooms and/or kits',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Meeting spaces and ballrooms',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'are all accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.3' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Public entrance alternative',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.1' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Registration Desk Pathway',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is not accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.10' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Registration desk',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Restaurant(s)/Lounge(s)',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'are all accessible', value: null }],
          categoryType: { __typename: 'Lookup', code: 'ADA.2' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Roll-in shower',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.110' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Service animals are welcome',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'PHY.29' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Shower wand, adjustable',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.115' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'TTY/TTD available ',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.116' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'TV with close-captioning ',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'PHY.45' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Toilet seat at wheelchair height',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.32' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Vanities, accessible',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.3' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Viewports, lowered',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'PHY.26' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'All public areas non-smoking',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.268' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'Car Rental, Nearby',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Hertz, 1-212-486-5925', value: null }],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'GNC', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.348' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Golden Times Nail and Foot Spa', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.348' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Oasis Day Spa', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.348' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Sephora Times Square', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.348' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'null' },
          description: 'Off-site parking',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.63' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'null' },
          description: 'Valet parking',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.97' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'HotelBlock' },
          description: 'This hotel has a smoke-free policy',
          details: [],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Accessibility' },
          description: 'Elevators',
          details: [],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Complimentary Services' },
          description: 'Coffee in lobby',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.140' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Continental breakfast, fee from',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: '25 USD', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.159' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Foreign exchange, nearby',
          details: [],
          categoryType: null,
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Full American breakfast, fee from',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: '35 USD', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.161' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Housekeeping',
          details: [
            {
              __typename: 'FacilitiesAndServicesDetails',
              key: 'Housekeeping Baseline',
              value: 'Yes - Housekeeping provided',
            },
            { __typename: 'FacilitiesAndServicesDetails', key: 'Housekeeping Frequency', value: 'Daily' },
            { __typename: 'FacilitiesAndServicesDetails', key: 'Housekeeping Service Description', value: 'Refresh' },
          ],
          categoryType: { __typename: 'Lookup', code: 'HACKOR.50' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Housekeeping service daily',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HACKOR.50' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Mobility accessible rooms',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.258' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Newspaper in lobby',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.145' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Safe deposit boxes, front desk',
          details: [],
          categoryType: { __typename: 'Lookup', code: 'HAC.78' },
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', code: 'Guest Services' },
          description: 'Valet dry-cleaning',
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Back in 6 Days', value: null }],
          categoryType: { __typename: 'Lookup', code: 'HAC.96' },
        },
      ],
      matchingSearchFacets: [
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'business-center', description: 'Business center' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'fitness-center', description: 'Fitness center' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'free-internet', description: 'Free high-speed internet' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'internet', description: 'High-speed internet at a price' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'pet-friendly', description: 'Pet friendly' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'restaurant-on-site', description: 'Restaurant on-site' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'parking', description: 'Parking' },
        },
        {
          __typename: 'PropertySearchFacetMatch',
          dimension: { __typename: 'Lookup', code: 'meeting-space', description: 'Meeting event space' },
        },
      ],
      contactInformation: {
        __typename: 'PropertyContactInformation',
        contactNumbers: [
          { __typename: 'ContactNumber', number: '+12128406800' },
          { __typename: 'ContactNumber', number: '+12129441419' },
        ],
      },
    },
  },
  accessibilityData: {
    property: {
      __typename: 'Hotel',
      facilitiesAndServices: [
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Equipment' },
          description: 'Computers',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'BUS.1', label: null, description: 'Computers' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Equipment' },
          description: 'Printers',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'BUS.28', label: null, description: 'Printers' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Copy service',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'BUS.2', label: null, description: 'Copy service' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Fax service',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'BUS.9', label: null, description: 'Fax service' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Full business center, onsite',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'BUSKOR.72',
            label: null,
            description: 'Full business center, onsite',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Full-service business center',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'BUS.71',
            label: null,
            description: 'Full-service business center',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Network/Internet printing',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'BUS.57',
            label: null,
            description: 'Network/Internet printing',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Business Services' },
          description: 'Overnight delivery/pickup',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'BUS.62',
            label: null,
            description: 'Overnight delivery/pickup',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Accessible guest rooms with 32” wide doorways',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'ADA.11',
            label: null,
            description: 'Accessible guest rooms have a 32 inch wide opening',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Accessible route from public entrance to accessible guest rooms ',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'ADA.12',
            label: null,
            description: 'Route to accessible guest rooms is accessible',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Alarm clock telephone ringers',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.39',
            label: null,
            description: 'Telephone for hearing impaired',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Bathroom grab bars',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.38', label: null, description: 'Grab bars in bathroom' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Bathtub grab bars',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.114', label: null, description: 'Bathtub grab bars' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Bathtub seat',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.44', label: null, description: 'Bathtub seat' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Business Center ',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.7', label: null, description: 'Business center entrance' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Deadbolt locks, lowered',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.17',
            label: null,
            description: 'Lowered deadbolt in guest room for disabled persons height (in feet)',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Door night guards, lowered',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.112',
            label: null,
            description: 'Lowered night guards on guest room doors',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Doors with lever handles',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: null,
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'All Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Electrical outlets, lowered',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.113',
            label: null,
            description: 'Lowered electrical outlets',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Fitness Center ',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.6', label: null, description: 'Fitness center entrance' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Flashing door knockers',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.13',
            label: null,
            description: 'Flashing door knocker available for disabled person',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Hearing accessible rooms and/or kits',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: null,
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Meeting spaces and ballrooms',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.3', label: null, description: 'Meeting spaces' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'are all accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Public entrance alternative',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.1', label: null, description: 'Main entrance' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Registration Desk Pathway',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.10', label: null, description: 'Registration desk' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is not accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Registration desk',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: null,
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'is accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Restaurant(s)/Lounge(s)',
          groupId: 'AAP',
          groupName: 'Accessible Areas with Accessible Routes from Public Entrance',
          categoryType: { __typename: 'Lookup', code: 'ADA.2', label: null, description: 'Restaurants and lounges' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'are all accessible', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Roll-in shower',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.110', label: null, description: 'Roll-in shower' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Service animals are welcome',
          groupId: 'AHF',
          groupName: 'Accessible Hotel Features',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.29',
            label: null,
            description: 'Service animals allowed for persons with disabilities',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Shower wand, adjustable',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.115',
            label: null,
            description: 'Adjustable height hand-held shower wand',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'TTY/TTD available ',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.116', label: null, description: 'TTY/TTD compatible' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'TV with close-captioning ',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'PHY.45', label: null, description: 'Closed-caption TV' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Toilet seat at wheelchair height',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.32',
            label: null,
            description: 'Toilet seat in guest rooms for disabled person',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Vanities, accessible',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.3',
            label: null,
            description: 'Bathroom vanity in guest rooms for disabled person height',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Viewports, lowered',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: {
            __typename: 'Lookup',
            code: 'PHY.26',
            label: null,
            description: 'Peephole in guest room for disabled person height (in ft)',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'All public areas non-smoking',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.268',
            label: null,
            description: 'All public areas non-smoking',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'Car Rental, Nearby',
          groupId: null,
          groupName: null,
          categoryType: null,
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Hertz, 1-212-486-5925', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.348',
            label: null,
            description: 'Health and beauty services',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'GNC', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.348',
            label: null,
            description: 'Health and beauty services',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Golden Times Nail and Foot Spa', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.348',
            label: null,
            description: 'Health and beauty services',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Oasis Day Spa', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Facilities' },
          description: 'Health & Beauty Services',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.348',
            label: null,
            description: 'Health and beauty services',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Sephora Times Square', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: null },
          description: 'Off-site parking',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HAC.63', label: null, description: 'Off-Site parking' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: null },
          description: 'Valet parking',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HAC.97', label: null, description: 'Valet parking' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: null },
          description: 'This hotel has a smoke-free policy',
          groupId: null,
          groupName: null,
          categoryType: null,
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Accessibility' },
          description: 'Elevators',
          groupId: 'AHF',
          groupName: 'Accessible Hotel Features',
          categoryType: null,
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Complimentary Services' },
          description: 'Coffee in lobby',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.140',
            label: null,
            description: 'Complimentary coffee in lobby',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Continental breakfast, fee from',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HAC.159', label: null, description: 'Continental breakfast' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: '25 USD', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Foreign exchange, nearby',
          groupId: null,
          groupName: null,
          categoryType: null,
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Full American breakfast, fee from',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.161',
            label: null,
            description: 'Full american breakfast',
          },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: '35 USD', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Housekeeping',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HACKOR.50', label: null, description: 'Housekeeping' },
          details: [
            {
              __typename: 'FacilitiesAndServicesDetails',
              key: 'Housekeeping Baseline',
              value: 'Yes - Housekeeping provided',
            },
            { __typename: 'FacilitiesAndServicesDetails', key: 'Housekeeping Frequency', value: 'Daily' },
            { __typename: 'FacilitiesAndServicesDetails', key: 'Housekeeping Service Description', value: 'Refresh' },
          ],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Housekeeping service daily',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HACKOR.50', label: null, description: 'Housekeeping' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Mobility accessible rooms',
          groupId: 'GRA',
          groupName: 'Guest Room Accessibility',
          categoryType: { __typename: 'Lookup', code: 'HAC.258', label: null, description: 'Accessible rooms' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Some Rooms/Suites', value: null }],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Newspaper in lobby',
          groupId: null,
          groupName: null,
          categoryType: {
            __typename: 'Lookup',
            code: 'HAC.145',
            label: null,
            description: 'Complimentary newspaper in lobby',
          },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Safe deposit boxes, front desk',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HAC.78', label: null, description: 'Safe deposit box' },
          details: [],
        },
        {
          __typename: 'HotelFacilitiesAndServices',
          type: { __typename: 'Lookup', description: 'Guest Services' },
          description: 'Valet dry-cleaning',
          groupId: null,
          groupName: null,
          categoryType: { __typename: 'Lookup', code: 'HAC.96', label: null, description: 'Dry cleaning' },
          details: [{ __typename: 'FacilitiesAndServicesDetails', key: 'Back in 6 Days', value: null }],
        },
      ],
      contactInformation: {
        __typename: 'PropertyContactInformation',
        contactNumbers: [
          { __typename: 'ContactNumber', number: '+12128406800' },
          { __typename: 'ContactNumber', number: '+12129441419' },
        ],
      },
    },
  },
  propertyId: 'NYCAK',
  brandCode: 'AK',
  pageProps: { render: 'server', noi18n: '1', mc: '1' },
};
